import {
  ActiveInactiveStatus,
  ApiListResponse,
  MembershipBean,
  MembershipType,
} from "@gymflow/types";

import { createAxiosInstance } from "../createAxiosInstance";

export type PublicMembershipApiType = ReturnType<typeof publicMembershipApi>;

const publicMembershipApi = (apiUrl: string, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const axiosInstance = createAxiosInstance({
    apiUrl,
  });

  return {
    getById(id: number) {
      return axiosInstance.get<MembershipBean>(
        `${clubPrefix}hosted/membership/${id}`,
      );
    },
    getList(params: {
      status?: ActiveInactiveStatus;
      id?: number[];
      page: number;
      size: number;
      sort?: string;
      type?: MembershipType;
      isTrial?: boolean;
    }) {
      return axiosInstance.get<ApiListResponse<MembershipBean>>(
        `${clubPrefix}hosted/membership`,
        {
          params,
        },
      );
    },
  };
};

export default publicMembershipApi;
